import { Injectable, Injector } from '@angular/core';
import { UserPermissionsDto } from '@common-modules/shared/model/roles/user-permissions.dto';
import { Observable, of } from 'rxjs';

@Injectable()
export class TCRolesService {
  constructor(injector: Injector) {}

  getProfileDialogsPathsByCurrentUser(): Observable<UserPermissionsDto> {
    const mock: UserPermissionsDto = {
      isSuperUser: true,
      userCode: 'mock',
      permissions: [],
    };
    return of(mock);
  }
}
